module.exports = __webpack_public_path__ + "static/media/studentdashboard-right.7791e723.png";